export default __webpack_public_path__ + "static/media/solo_ico.c4face05.svg";